import { Grid, TextField } from '@mui/material';

const AdditionalInformationSection = ({ t, userData, onSetData }) => (
  <Grid className="personal-data__card personal-data__card--address">
    <h4 className="sub_head">{t('personalData.Additional_Information')}</h4>
    <Grid className="personal-data__card-head">
      <Grid>
        <TextField
          label={t('personalData.VAT_Number')}
          placeholder={t('personalData.VAT_Number')}
          fullWidth
          value={userData?.vatNumber || ''}
          onChange={onSetData}
          name="vatNumber"
          className="personal-data__text-field"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid>
        <TextField
          label={t('personalData.ATE_Break_Center_ID')}
          placeholder={t('personalData.ATE_Break_Center_ID')}
          fullWidth
          value={userData?.brakeCenterId || ''}
          onChange={onSetData}
          name="brakeCenterId"
          className="personal-data__text-field"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default AdditionalInformationSection;
